import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { APP_SETTINGS, StyleguideModule } from '@woolworthsnz/styleguide';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AppSettings } from './app.settings';
import { TraderBridgeComponent } from './trader-bridge/trader-bridge.component';
import {StoreModule } from '@ngrx/store';


@NgModule({
	declarations: [AppComponent, TraderBridgeComponent],
	imports: [BrowserModule, AppRoutingModule, HttpClientModule, StyleguideModule.forRoot(),
			StoreModule.forRoot({}, {})],
	providers: [{ provide: APP_SETTINGS, useValue: AppSettings ,

		
	}],
	bootstrap: [AppComponent],
})
export class AppModule {}
